import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';

import Layout from 'app/views/Layout';
import LoginContainer from 'containers/LoginContainer';
import DashboardContainer from 'containers/DashboardContainer';
import * as academy from 'containers/academy';
import * as company from 'containers/company';
import * as ATS from 'containers/ATS';
import * as profile from 'containers/profile';
import * as candidates from 'containers/candidates';
import * as reports from 'containers/reports';
import NotFound from 'app/views/NotFound'
import './styles/index.css';

const App = () => (
	<div>
  	<Layout>
	    <main>
	      <Switch>
	        <Route exact path='/' component={LoginContainer} />
	        <Route exact path='/dashboard' component={DashboardContainer} />
	        <Route exact path='/onboard/academy' component={academy.AcademyOnboardContainer} />
	        <Route exact path='/onboard/academy/success' component={academy.AcademyOnboardSuccessContainer} />
	        <Route exact path='/onboard/company' component={company.CompanyOnboardContainer} />
	        <Route exact path='/onboard/company/success' component={company.CompanyOnboardSuccessContainer} />
	        <Route exact path='/onboard/ATS' component={ATS.ATSOnboardContainer} />
	        <Route exact path='/onboard/ATS/success' component={ATS.ATSOnboardSuccessContainer} />
	        <Route exact path='/forget-password' component={profile.ForgetPasswordContainer} />
	        <Route exact path='/password/reset' component={profile.ResetPasswordContainer} />
	        <Route exact path='/change-password' component={profile.ChangePasswordContainer} />
	        <Route exact path='/password/change' component={profile.ChangePasswordContainer} />
	        <Route path='/reports/:studentId/details/:query' component={reports.ReportDetailsContainer} />
	        <Route exact path='/candidates' component={candidates.CandidatesContainer} />
	        <Route path='*' component={NotFound}/>
	      </Switch>
	    </main>
   	</Layout>
	</div>
);

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js